import { keccak256 } from 'viem';

export function roundTo(num: number, dec: number): number {
  const pow = Math.pow(10, dec);
  return Math.round((num + Number.EPSILON) * pow) / pow;
}

export function floorTo(num: number, dec: number): number {
  const pow = Math.pow(10, dec);
  return Math.floor(num * pow) / pow;
}

/**
 * Converts a float value to a BigInt, rounding down to 4 decimals and scaling to token decimals.
 * @param value The input value (float)
 * @param tokenDecimals The number of decimals the token uses (e.g., 6 for USDC)
 * @returns BigInt representation for contract use
 */
export function toTokenAmountBigInt(value: number, tokenDecimals: number): bigint {
  // 1. Round down to 4 decimals
  const floored = Math.floor(value * 10_000) / 10_000;
  // 2. Convert to integer (remove decimals)
  const asInt = Math.floor(floored * 10_000);
  // 3. Scale to token decimals
  const scale = 10 ** (tokenDecimals - 4);
  // 4. Return as BigInt
  return BigInt(asInt * scale);
}

export function FriendlyFormatNumber(num: number): string {
  if (num == 0) {
    return '0';
  }

  if (num === null) {
    return '0';
  }

  if (num > 1e9) {
    return `${roundTo(num / 1e9, 2)}B`;
  } else if (num > 1e6) {
    return `${roundTo(num / 1e6, 2)}M`;
  } else if (num > 1e3) {
    return `${roundTo(num / 1e3, 2)}K`;
  } else if (num < 1 / 1e3) {
    // For very small numbers, use toFixed with more decimal places
    return num.toFixed(6);
  } else {
    return `${roundTo(num, 4).toString()}`;
  }
}

export function networkToInstanceName(network: string) {
  if (!network) {
    return '';
  }
  switch (network.toLowerCase()) {
    case 'starknet':
      return 'rUSDC-stark';
    case 'morph':
      return 'rUSDC-morph';
    case 'tac':
      return 'rUSDC-tac';
    case 'bitlayer':
      return 'rUSDC-bit';
    case 'swellchain':
      return 'rUSDC-swell';
    case 'sonic':
      return 'rUSDC-sonic';
    case 'soneium':
      return 'rUSDC-soneium';
    case 'monad':
      return 'rUSDC-monad';
    case 'bsc':
      return 'rUSDC-bsc';
    case 'arbitrum':
      return 'rUSDC-arbi';
    case 'optimism':
      return 'rUSDC-opti';
    case 'hemi':
      return 'rUSDC-hemi';
    default:
      return network;
  }
}

export function getTestnetFakeTVL(tokenSymbol: string): number {
  const hash = keccak256(new TextEncoder().encode(tokenSymbol));

  const hashNumber = BigInt('0x' + hash.slice(2, 18));

  return Number((hashNumber % BigInt(15000000)) + BigInt(5000000));
}
